<template>
  <lay-tab type="brief" v-model="active" @change="change" style="margin: 0">
    <lay-tab-item v-for="(item, index) in fms"  v-bind:key="index"  :id="index" >
      <template #title>
        <lay-icon :type="item.avatar"></lay-icon>
        <span style="margin-left: 10px;display: inline-block;">{{item.title}}</span>
      </template>
    </lay-tab-item>
  </lay-tab>
</template>

<script setup>
import {defineProps, ref} from "vue";
import {useRouter} from "vue-router/dist/vue-router";
const  props = defineProps(['fms'])
const active = ref(0)
const router = useRouter();
const change = (id) => {
  router.push(props.fms[id].hash)
}

</script>

<style scoped>
.main{
  margin:0;
  background-color: var(--global-neutral-color-2);
}
</style>